// extracted by mini-css-extract-plugin
export default {"time-status":"style_time-status__zhSsy"};